export enum CSS {
    ARROW_ICON='arrow-icon',
    BACKGROUND='background',
    BUTTON_DARK='button-dark',
    CARD_TITLE='card-title',
    CARD_SUBTITLE='card-subtitle',
    CLOSED_MENU='closed-menu',
    COLLAB_WRAPPER='collab-wrapper',
    COLLABORATION_CARD='collaboration-card',
    COLLABORATION_TEXT='collaboration-text',
    COMING_SOON='coming-soon',
    COMING_SOON_ROUTE='coming-soon-route',
    CONSULTATION='consultation',
    CONSULT_WRAPPER='consult-wrapper',
    CONTAINER='container',
    CONTACT='contact',
    CONTACT_BUTTON='contact-button',
    CONTACT_LINK='contact-link',
    CUSTOMIZIZATION_CARD='customization-card',
    DISCOVER_CARD='discover-card',
    DISCOVER_CARD_LIST='discover-card-list',
    DISCOVER_CARD_LIST_ITEM='discover-card-list-item',
    DISPLAY_BIGSCREEN='display-bigscreen',
    DISPLAY_GIANTSCREEN='display-giantscreen',
    DISPLAY_SMALLSCREEN='display-smallscreen',
    EMAIL_INPUT='email-input',
    FLEX_ROW='flex-row',
    FLEX_COLUMN='flex-column',
    FOOTER='footer',
    FOOTER_INFO='footer-info',
    FOOTER_LOGO='footer-logo',
    FOOTER_LEGAL='footer-legal',
    FULL_HEIGHT='full-height',
    HEADER='header',
    MENU_BUTTON='menu-button',
    LAST='last',
    LAPTOP_IMG='laptop-img',
    LEFT_MARGIN='left-margin',
    LINKEDIN_BTN='linkedin-btn',
    LINKEDIN_BIGSCREEN='linkedin-bigscreen',
    LINKEDIN_SMALLSCREEN='linkedin-smallscreen',
    LINKS='links',
    LINKS_SMALLSCREEN='links-smallscreen',
    LINK_COLUMN='link-column',
    LOGO='logo',
    LOGO_DARK='logo-dark',
    LOGO_SCROLLER='logo-scroller',
    NEWSLETTER='newsletter',
    MAIN_TEXT='main-text',
    IMG_WRAPPER='img-wrapper',
    TEXT_LINK='text-link',
    TEXT='text',
    TITLE_CARD='title-card',
    TITLE_CARD_TITLE='title-card-title',
    THIN_ARROW='c',
    OPEN_MENU='open-menu',
    OUR_PLATFORM_BUTTON='our-platform-button',
    PADDING='padding',
    PARTNERS_TITLE='partners-title',
    PARTNERS='partners',
    PRIVACY_CARD_HORIZONTAL='privacy-card-horizontal',
    PRIVACY_CARD_VERTICAL='privacy-card-vertical',
    PRIVACY_TEXT='privacy-text',
    PRIVACY_SUBTEXT='privacy-subtext',
    PROTECT_DATA='protect-data',
    SECURE_DATA_TITLE='secure-data-title',
    SECURE_DATA_CARD='secure-data-card',
    SECURE_DATA_IMG='secure-data-img',
    SECURE_DATA_IMG_MOBILE='secure-data-img-mobile',
    SECURE_DATA_FIRST_ROW='secure-data-first-row',
    SIDE_MENU='side-menu',
    SUB_TEXT='sub-text',
    WRAPPER='wrapper',
}
